/**
 * TODO move this into MUI theme components definition as a button variant
 * PrimaryButton created during LIFT Portal development
 */

import { buttonClasses, useTheme } from '@mui/material';

import { COLORS } from '@tbd/life-tokens';
import { TextButton } from '@tbd/lift-ui/components/TextButton';
import type { TextButtonProps } from '@tbd/lift-ui/components/TextButton';

export type PrimaryButtonProps = Omit<TextButtonProps, 'variant'>;

export function PrimaryButton({ sx, ...props }: PrimaryButtonProps) {
  const theme = useTheme();
  return (
    <TextButton
      variant="primary"
      sx={{
        borderRadius: '4px',
        boxShadow: 'unset',
        ...theme.typography['component-bold-s'],
        [`&.${buttonClasses.disabled}`]: {
          // Use original color with opacity
          color: COLORS.white,
          backgroundColor: COLORS.accent1_500,
          opacity: 0.3,
        },
        ...(sx ?? {}),
      }}
      {...props}
    />
  );
}
